import Image from 'next/image';
import { memo } from 'react';
import { Marker, Popup } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { iconActivity } from '../assets/marker';
import { MarkerClusterIcon } from '../marker-cluster-icon';
import type { useMapPointOfInterests } from '../useMapPointOfInterests';
const ActivitiesMarkerContent = ({
  activities,
  isActivitiesDisplayed,
}: {
  activities: ReturnType<typeof useMapPointOfInterests>['activities'];
  isActivitiesDisplayed: boolean;
}) => {
  // const t = useTranslations('Home.Map');
  return (
    <MarkerClusterGroup
      chunkedLoading
      iconCreateFunction={() => MarkerClusterIcon(iconActivity)}
    >
      {isActivitiesDisplayed &&
        activities?.map((marker, index) => (
          <Marker
            icon={iconActivity}
            key={marker.title + marker.coordinates.join(',') + index}
            position={[marker.coordinates[1], marker.coordinates[0]]}
          >
            <Popup>
              <div className="flex flex-col gap-4">
                <p>{marker.title}</p>

                {marker.image && (
                  <Image
                    unoptimized
                    src={marker.image}
                    alt={marker.title}
                    width={560}
                    height={500}
                    className="rounded-lg"
                  />
                )}
                {/*marker.url && (
                  <Link href={marker.url} target="_blank">
                    {t('Voir sur France Vélo tourisme')}
                  </Link>
                )*/}
              </div>
            </Popup>
          </Marker>
        ))}
    </MarkerClusterGroup>
  );
};

export const ActivitiesMarker = memo(ActivitiesMarkerContent);
